/*
 * Carousel arrows for native horizontal scrollers (product rows).
 *
 * Markup contract:
 *   <div data-mv-scroller>
 *     <button type="button" data-mv-scroller-prev>…</button>
 *     <button type="button" data-mv-scroller-next>…</button>
 *     <ul data-mv-scroller-track>…</ul>      (overflow-x: auto + scroll-snap in CSS)
 *   </div>
 *
 * Scrolling works without this script (touch, trackpad, keyboard). The script
 * only moves the track by one visible page per click, disables an arrow at the
 * end it points to, and sets [data-overflow="false"] on the root when all cards
 * fit, so CSS can hide the arrows. Re-initialises after theme editor reloads.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.__mvScroller) return;
    var track = root.querySelector('[data-mv-scroller-track]');
    if (!track) return;
    var prev = root.querySelector('[data-mv-scroller-prev]');
    var next = root.querySelector('[data-mv-scroller-next]');
    root.__mvScroller = true;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 2;
      root.setAttribute('data-overflow', overflow ? 'true' : 'false');
      if (prev) prev.disabled = !overflow || track.scrollLeft <= 2;
      if (next) next.disabled = !overflow || track.scrollLeft >= max - 2;
    }

    function page(direction) {
      var first = track.firstElementChild;
      var step = track.clientWidth;
      if (first) {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var card = first.getBoundingClientRect().width + gap;
        if (card > 0) step = Math.max(card, Math.floor((track.clientWidth + gap) / card) * card);
      }
      track.scrollBy({
        left: direction * step,
        behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth',
      });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    var frame = 0;
    track.addEventListener(
      'scroll',
      function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = 0;
          update();
        });
      },
      { passive: true }
    );

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mv-scroller]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
